import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BurdSameDayDeliveryService } from '@shared/same-day-delivery/burd-same-day-delivery.service';
import { SettingsService } from '@core/services/settings.service';
import { SameDayDeliveryStatus } from '../same-day-delivery.model';
import { CustomTimerPipe } from '../custom-timer.pipe';
import { TimeLimitPipe } from '../time-limit.pipe';
import { TimeRemainingPipe } from '@shared/same-day-delivery/time-remaining.pipe';
import { TranslateSafePipe } from '../../translate-safe/translate-safe.pipe';
import { SafePipe } from '@shared/safe/safe.pipe';
import { TooltipComponent } from '../../tooltip/tooltip.component';
import { SvgIconComponent } from '../../svg-icon/svg-icon.component';
import { NgIf, AsyncPipe, DatePipe } from '@angular/common';
import { LoadingDotsComponent } from '../../loading-dots/loading-dots.component';

@UntilDestroy()
@Component({
    selector: 'app-same-day-delivery-count-down',
    templateUrl: './same-day-delivery-count-down.component.html',
    styleUrls: ['./same-day-delivery-count-down.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LoadingDotsComponent, NgIf, SvgIconComponent, TooltipComponent, AsyncPipe, DatePipe, SafePipe, TranslateSafePipe, TimeRemainingPipe, TimeLimitPipe, CustomTimerPipe]
})
export class SameDayDeliveryCountDownComponent implements OnInit {
    public timeLeft?: Date;
    public showCounter: boolean = false;

    @Input() showIcon: boolean = true;
    @Input() zipCode?: string;
    @Input() status: SameDayDeliveryStatus = 'Idle';
    @Input() longTimeFormat: boolean = false;
    @Input() showTooltip: boolean;

    constructor(
        public settingsService: SettingsService,
        private burdSameDayDeliveryService: BurdSameDayDeliveryService,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.burdSameDayDeliveryService
            .getBurdDeliveryTimeLeft()
            .pipe(untilDestroyed(this))
            .subscribe(({ secondsLeft = 0, onTimeForSameDayDelivery }) => {
                this.showCounter = onTimeForSameDayDelivery || false;
                const endDate = new Date();
                endDate.setSeconds(endDate.getSeconds() + Math.round(secondsLeft) + 1);
                this.timeLeft = endDate;
                this.cd.markForCheck();
            });
    }
}
